import { getPreviews } from '../utils';
import {
  Box, Button, Text,
  useMediaQuery, useStyleConfig,
} from '@chakra-ui/react';
import React, { useState } from 'react';
import Actions from './components/Actions';
import Sections from './components/Sections';
import Header from './components/Header';
import Instructions from './components/Instructions';
import { downloadCoverLetter, onLink } from '../../handlers';
import { getUsefulVars } from '../../handlers/helpers';
import { FaDownload } from 'react-icons/fa';
import { editResults } from './utils';

const Preview = ({ props }) => {
  const uv = getUsefulVars(props);
  const myData = uv.stateProps.dataToSave.saved.resumes[uv.resumeIndex];
  const variant = 'wrapper';
  const styles = {};
  styles.previewLetter = useStyleConfig('PreviewLetter', { variant });
  styles.button = useStyleConfig('Button', { variant });
  uv.stateProps.setRegenCS(false);
  const isDesktop = useMediaQuery('(min-width: 768px)', { ssr: false });
  const previewWidth = isDesktop[0] ? '70%' : '95%';
  const [isAccordion, setIsAccordion] = useState(true);
  if (myData) {
    const previews = getPreviews(myData, props.navSections);
    return (
      <Box sx={{ ...styles.previewLetter }}>
        <Header props={props} />
        <Box className="previewWrapper">
          <Box className="sectionWrapper" margin="0 auto">
            <Instructions props={props} isAccordion={isAccordion} setIsAccordion={setIsAccordion} />
            <Sections myData={myData} props={props} previews={previews} styles={styles} isDesktop={isDesktop} />
          </Box>
        </Box>
        <Box width="70%" display="flex" justifyContent="space-between" margin="1rem auto">
          <Button
            sx={{ ...styles.button.primary, ...styles.button.singleSectionMenu }}
            onClick={() => onLink(false, uv.formikProps, uv.stateProps, 'menu', 0, 'section', uv.resumeIndex)}
          >
            &lt;&lt; Menu
          </Button>
          <Button
            marginTop="1rem"
            onClick={() => editResults(uv, props)}
          >
            Start Over
          </Button>

          <Button
            marginTop="1rem !important"
            leftIcon={<FaDownload />}
            onClick={e => downloadCoverLetter(props)}

            sx={{ ...styles.button.download }}
          >
            Download
          </Button>

        </Box>
      </Box>
    );

  } else {
    return null;
  }
};
export default Preview;

/*

          <Box className='actionWrapper' >
            <Actions myData={myData} props={props} previews={previews} styles={styles} isDesktop={isDesktop} />
          </Box>
            <Heading marginBottom='1.1rem'>Actions</Heading>
 */
/*
            <Header props={props} />
            <Instructions props={props} isAccordion={isAccordion} setIsAccordion={setIsAccordion} />
*/